module.exports = __webpack_public_path__ + "./docs/img/icon-git.0517bdcc6d7be10eff7292380bb9754e.svg";